export const updateOptions = (a, type) => {       
    return {
      type: type,  // Динамический тип, который вы передаете в экшен
      payload: a,   // Динамическое значение для фильтра (true или false или любое другое значение)
    };
  };
  